import React from "react";
import ReactDOM from "react-dom/client";
import "@/i18n/i18n";
import App from "@/App";
import "@/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Defer analytics loading after initial render to reduce blocking JavaScript
// Load after 3 seconds or after user interaction, whichever comes first
let analyticsLoaded = false;

const loadAnalytics = () => {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  import("@vercel/analytics").then(({ inject }) => inject());
  import("@vercel/speed-insights").then(({ injectSpeedInsights }) => injectSpeedInsights());
};

// Load after 3 seconds
setTimeout(loadAnalytics, 3000);

// Or load on first user interaction
const interactionEvents = ["mousedown", "touchstart", "keydown", "scroll"];
interactionEvents.forEach((event) => {
  document.addEventListener(event, loadAnalytics, { once: true, passive: true });
});
